const messages = {
  availPoints: "Points disponibles",
  awaitingPoints: "Points en attente",
  board: {
    title: "Tableau de bord",
    title2: "Animation Performance {year}",
    headline1: "Vos animations et vos points en un coup d'œil",
    headline2: "Gagnez des points pour vos achats de pneus.",
    pointsBalanceToDate: "SOLDE DE POINTS A DATE",
    availPoints: "Points disponibles",
    awaitingPoints: "Points en attente",
    yourRealisation: "VOS RÉALISATIONS",
    yourEngagement: "Votre engagement annuel: <b>{tyres} pneus</b>",
    yourPoints: "VOS POINTS",
    yourRetailPurchase: "VOS ACHATS EN DÉTAIL",
    yourRetailPurchaseCCS: "VOS VENTES EN DÉTAIL",
    pointsByPurchase: "points générés par vos achats",
    pointsByBoosters: "points générés par les boosters",
    pointsByBSPurchase: "Points générés par vos achats auprès de Bridgestone",
    pointsByBSPurchaseCCS:
      "Points générés par vos Ventes de pneumatiques Bridgestone",
    remaining: "PNEUS RESTANTS",
    yourGoal: "Progression objectif",
    unit: "pneus",
    buttons: {
      learnMore: "En Savoir Plus sur vos points",
      learnMoreAboutMechanism: "En savoir plus sur la mécanique",
    },
    charts: {
      byBrand: "Par marque",
      bySize: "Par taille<br/>de jante",
    },
    exploreResults: "Découvrez vos résultats",
    tyreLimitInfo:
      "Un volume sell-out de minimum 50 pneumatiques des marques Bridgestone et/ou Firestone est requis pour chaque période de l’animation Booster",
  },
  charts: {
    byBrand: "Par marque",
    bySize: "par taille de jante",
  },
  dashboard: {
    dashboardTitle: "Vos avantages",
    dashboardBox: {
      title: "Solde de points",
      description: "Votre nombre actuel de points marketing",
      availPoints: "Points disponibles",
      awaitingPoints: "Points en attente",
      lastUpdate: "Dernière mise à jour",
      button: "En Savoir Plus",
      points: "points",
    },
  },
  soldTyres: "PNEUS VENDUS",
  receivedPoints: "POINTS GAGNÉS",
  boosterCCS: {
    personalInfo: "Informations personnelles",
    csNumberTitle: "Veuillez préciser le(s) n° de compte(s) participant(s)",
    tyresTitle: "Veuillez préciser le nombre de pneus vendus",
    minTyresInfo:
      "Un minimum de {tyres} pneus Bridgestone/Firestone est requis. La rémunération s’applique uniquement sur les pneus Bridgestone.",
    tyresAmount: "Nb pneus",
    filesTitle: "Veuillez télécharger vos preuves de ventes",
    filesDescription:
      "À noter: seules les ventes mentionnant la dimension de jante des pneumatiques seront prises en compte.",
    addAnotherFile: "Ajouter un document",
    file: "Télécharger document",
    formatInfo:
      "Formats de fichier acceptés : xlsx, jpeg et pdf. Taille maximale du fichier: 8 MB",
    confrimationMessage:
      "Merci pour votre participation! <br/>Votre demande a bien été prise en compte et transmise aux équipes Bridgestone pour validation.<br/>Vous recevrez une notification par e-mail concernant les résultats de votre participation à l’animation Booster CCS.<br/>À très bientôt sur Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Partager des points",
    forShare: "Points que vous partagerez",
    title: "Titre",
  },
  notFoundFile: "Aucun sélectionné",
  chooseFile: "Sélectionner un fichier",
};
export default {
  messages,
};
